import { render, staticRenderFns } from "./SweetAlertHeader.vue?vue&type=template&id=e6612b10&scoped=true"
import script from "./SweetAlertHeader.vue?vue&type=script&lang=js"
export * from "./SweetAlertHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6612b10",
  null
  
)

export default component.exports